export default __webpack_public_path__ + "static/media/viber_image_2022-06-03_11-39-59-469.5dbcc738.jpg";